import { LocalViewsContext } from "@on-site/features/top/providers/LocalViewsProvider";
import { useContext } from "react";

export const useLocalViewsStore = () => {
  const context = useContext(LocalViewsContext);

  if (!context) throw new Error("useLocalViews must be used within a LocalViewsContext");

  return context;
};
